<script>
import CheatingCheckForm from "@/view/pages/classes/EvalutionItems/CheatingCheckForm.vue";
import EvaluationItem from "@/view/pages/classes/EvaluationItem.vue";
import CheatingConfirmModal from "@/view/pages/classes/CheatingConfirmModal.vue";
import CheckHasTest from "./CheckHasTest.vue";
import ConfirmNotHasTestModal from "./ConfirmNotHasTestModal.vue";

export default {
  name: "Evaluation",
  components: {CheatingConfirmModal, EvaluationItem, CheatingCheckForm,CheckHasTest,ConfirmNotHasTestModal},
  props: {
    evaluationData: {
      type: Object,
      default() {
        return null
      }
    },
    cheating: {
      type: Object,
      default() {
        return null
      }
    },
    isView:{
      type: Boolean,
      default(){
        return false
      }
    },
    didStudentDo: {
      type: Object,
      default() {
        return { value: true }
      }
    },
    isAI: {
      type: Boolean,
      default: false
    },
    isEntrance: {
      type: Boolean,
      default: false
    }
  },
  watch:{
    evaluationData(){
      this.activeName = 'Kiểm tra đạo văn'
    }
  },
  data() {
    return {
      activeName: 'Kiểm tra đạo văn',
      valueOne: null,
    };
  },
  computed: {
    doneCheating() {
      return !!((!this.cheating?.isCheating) || (this.cheating?.isCheating && this.cheating?.PlagiarismRate !== null && this.cheating?.comment !== ''));
    }
  },
  methods: {
    handleClick(tab, event) {
      if(this.cheating?.isCheating && +this.cheating?.PlagiarismRate === 1 && !this.isView){
        setTimeout(()=>{
          this.activeName = "Kiểm tra đạo văn"
        },0)
        event.preventDefault()
        this.$bvModal.show("Modal-Confirmed-Plagiarism")
      }
    },
    markZeroPoint(){
      this.evaluationData.items.forEach((evaluation) => {
        evaluation.comment_detail = ''
        evaluation.items.forEach((item) => {
          item.criterion_score = 0
          item.comment_auto = ''
        })
      })
      this.$emit('nextStep')
    },
    handleNotDone(){
      this.$bvModal.show("ModalConfirmNotHasTestModal")
    },
    cancelNotHaveTest() {
      this.didStudentDo.value = true
      this.$bvModal.hide("ModalConfirmNotHasTestModal")
    }
  }
}
</script>

<template>
  <el-tabs v-model="activeName" @tab-click="handleClick" >
    <el-tab-pane label="Kiểm tra đạo văn" name="Kiểm tra đạo văn">
      <CheckHasTest :didStudentDo="didStudentDo" @handleNotDone="handleNotDone" :isView="isView"></CheckHasTest>
      <CheatingCheckForm :cheating="cheating" :isView="isView"></CheatingCheckForm>
    </el-tab-pane>
    <el-tab-pane v-for="(evaluation,indexEvaluation) in evaluationData?.items" :key="evaluation.label"
                 :label="evaluation.label" :name="evaluation.label" :disabled="!doneCheating || !didStudentDo.value" >
      <div style="max-height: 600px; overflow: auto">
        <EvaluationItem :evaluation="evaluation" :isView="isView" :isEntrance="isEntrance"></EvaluationItem>
        <div class="marking-box">
          <label style="font-weight: bold">Nhận xét cụ thể, dẫn chứng <span style="color:red;">*</span></label>
          <el-input
              type="textarea"
              :rows="2"
              placeholder="Nhập nhận xét"
              v-model="evaluation.comment_detail"
              :disabled="isView || (!isEntrance && evaluation.disable)"

          >
          </el-input>
          <div v-if="(isEntrance || !evaluation.disable) && !isView" class="ai-hint">
            <span class="ai-hint-icon">✦</span>
            Nhận xét này được AI gợi ý, bạn có thể chỉnh sửa nếu cần
          </div>
        </div>
      </div>
    </el-tab-pane>
    <CheatingConfirmModal @markZeroPoint="markZeroPoint"></CheatingConfirmModal>
    <ConfirmNotHasTestModal @markZeroPoint="markZeroPoint" @cancel-not-have-test="cancelNotHaveTest"></ConfirmNotHasTestModal>
  </el-tabs>
</template>

<style scoped>
.marking-box {
  border: 1px solid #e0e0e0;
  padding: 16px;
  border-radius: 6px;
  background-color: #fafafa;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.ai-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  font-size: 13px;
  color: #8c8c8c;
}

.ai-hint-icon {
  color: #b37feb;
  font-size: 14px;
}

</style>